import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';


export class Masterdata extends BaseEntity {
    id: string;
    name: string;
    code: string;
    type: string;
}

export class MasterdataAService extends BaseService<Masterdata> {

    private types: any = [];
    public apiItemName: string;
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'masterdata');

        this.setType('Skills', 'SKILLS');
        this.setType('Functions', 'Functions');
        this.setType('Hour codes', 'HourCodes');
        this.setType('Availability status', 'AvalabilityStatus');
        this.setType('Transportation type', 'TransportationType');
        this.setType('Note Tags', 'NoteTags');
        this.setType('Contact Tags', 'ContactTags');
        this.setType('Task Status', 'TaskStatus');
        this.setType('Preferred target audience', 'PreferredTargetAudience');
        this.setType('Application status', 'ApplicationStatus');
    }

    public setApiItemName = (name: string) => {
        this.apiItemName = name;
    }

    public setType = (name: string, id: string) => {
        this.types.push({"name": name, "id": id});
    }

    public setTypes = (types) => {
        this.types.push(types);
    }


    public getTypes = () => {
        return this.types;
    }


    public setItemName = (name:string) => {
        this.itemName = name;
        this.collection = this.Restangular.all(this.itemName);
        return true;
    }

    public postItem = (type: string, data: Masterdata) => {
        return this.collection.customPOST(data, type).then((response) => {
            this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            return response;
        }).catch(error => {
            this.AppService.NotifyService.error('Foutmelding', error);
            return error;
        });
    }

    public getItems = (type: string) => {
        return this.collection.customGET('types/' + type).then((response) => {
            return response.plain();
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/services/masterdata.service.ts